import { TenantEntity } from '../TenantEntity'
import { getCustomerTypeList } from '@/api/basicData/customerType'
import { getSpecialRequestList } from '@/api/partner/specialRequest'
import { getPortDestinationAgentList } from '@/api/partner/portDestinationAgent'

export class Customer extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get customerTypeId() {
    return this._data.customerTypeId
  }
  set customerTypeId(customerTypeId) {
    this._data.customerTypeId = customerTypeId
  }
  get ownerType() {
    return this._data.ownerType
  }
  set ownerType(ownerType) {
    this._data.ownerType = ownerType
  }
  get ownerClass() {
    return this._data.ownerClass
  }
  set ownerClass(ownerClass) {
    this._data.ownerClass = ownerClass
  }
  get designated() {
    return this._data.designated
  }
  set designated(designated) {
    this._data.designated = designated
  }
  get seftCanvass() {
    return this._data.seftCanvass
  }
  set seftCanvass(seftCanvass) {
    this._data.seftCanvass = seftCanvass
  }
  get peer() {
    return this._data.peer
  }
  set peer(peer) {
    this._data.peer = peer
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales
  }
  get ownerDepartment() {
    return this._data.ownerDepartment
  }
  set ownerDepartment(ownerDepartment) {
    this._data.ownerDepartment = ownerDepartment
  }
  get invoiceMode() {
    return this._data.invoiceMode
  }
  set invoiceMode(invoiceMode) {
    this._data.invoiceMode = invoiceMode
  }
  get overInvoicing() {
    return this._data.overInvoicing
  }
  set overInvoicing(overInvoicing) {
    this._data.overInvoicing = overInvoicing
  }
  get invoiceRemarks() {
    return this._data.invoiceRemarks
  }
  set invoiceRemarks(invoiceRemarks) {
    this._data.invoiceRemarks = invoiceRemarks
  }
  get priceLevel() {
    return this._data.priceLevel
  }
  set priceLevel(priceLevel) {
    this._data.priceLevel = priceLevel
  }
  get iTraceService() {
    return this._data.iTraceService
  }
  set iTraceService(iTraceService) {
    this._data.iTraceService = iTraceService
  }
  get iTraceStartDate() {
    return this._data.iTraceStartDate
  }
  set iTraceStartDate(iTraceStartDate) {
    this._data.iTraceStartDate = iTraceStartDate
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  get appointCurrency() {
    return this._data.appointCurrency
  }
  set appointCurrency(appointCurrency) {
    this._data.appointCurrency = appointCurrency
  }
  get currencyRequirements() {
    return this._data.currencyRequirements || 0
  }
  set currencyRequirements(currencyRequirements) {
    this._data.currencyRequirements = currencyRequirements
  }
  get oversea() {
    return this._data.oversea
  }
  set oversea(oversea) {
    this._data.oversea = oversea
  }
  async getCustomerType() {
    const data = this._data
    if (typeof data.customerType !== 'object') {
      data.customerType = await getCustomerTypeList({ typeId: data.customerTypeId }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
    }
    return data.customerType
  }
  async getSpecialRequests() {
    const data = this._data
    if (typeof data.specialRequests !== 'object') {
      data.specialRequests = await getSpecialRequestList({ customerUuid: data.uuid }).then(res => res.data)
    }
    return data.specialRequests
  }

  get portDestinationAgents() {
    return this._data.portDestinationAgents
  }
  set portDestinationAgents(portDestinationAgents) {
    this._data.portDestinationAgents = portDestinationAgents
  }
  async getPortDestinationAgents() {
    const data = this._data
    if (typeof data.portDestinationAgents !== 'object') {
      data.portDestinationAgents = await getPortDestinationAgentList({ customerUuid: data.uuid }).then(res => res.data)
    }
    return data.portDestinationAgents
  }
}
